module.exports = __webpack_public_path__ + "f4d0730a9b4ca1ac0937a0ccc6c2cd94.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/hu/google_store.png
// module id = 875
// module chunks = 0